import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import API_END_POINTS from '../../../core/constants/apiEndPoints';
import { Pagination } from '../../types/Pagination';
import { AreasResponse } from '../../types/Area';
import { ColumnProps } from '../../types/TableProps';
import { ProjectHighlight } from '../../types/ProjectHighlight';
import { WidgetCard } from '../../types/StatCard';
import { CwpResponse } from '../../types/Cwp';

const {
  REFRESH_DATA,
  DATA_QUALITY,
  HOME_CARD_DATA,
  FILES_REPORTS,
  GET_AREAS,
  CWP,
} = API_END_POINTS;

@Injectable({
  providedIn: 'root',
})
export class HomePageService {
  constructor(private http: HttpClient) {}

  refreshDetails(projectId : string): Observable<{
    status: string;
    data: {
      data: Record<string, any>[];
      columns: ColumnProps[];
    };
  }> {
    return this.http.get<{
      status: string;
      data: {
        data: Record<string, any>[];
        columns: ColumnProps[];
      };
    }>(REFRESH_DATA(projectId));
  }

  getCardDataByArea(
    area: string,
    projectId: string
  ): Observable<{ data: WidgetCard[] }> {
    return this.http.get<{ data: WidgetCard[] }>(
      HOME_CARD_DATA(projectId, area)
    );
  }

  getDataQualityTableData(
    projectId: string,
    data: Pagination,
    isDownloadClicked?: boolean
  ): Observable<{
    data: {
      columns: ColumnProps[];
      data: ProjectHighlight[];
      downloadData?: ProjectHighlight[];
      downloadCount?: number;
      count: number;
    };
  }> {
    return this.http.post<{
      data: {
        columns: ColumnProps[];
        data: ProjectHighlight[];
        downloadData?: ProjectHighlight[];
        downloadCount?: number;
        count: number;
      };
    }>(DATA_QUALITY, { ...data, projectId, isDownloadClicked });
  }

  getReports(): Observable<{ data: { key: string }[] }> {
    return this.http.get<{ data: { key: string }[] }>(FILES_REPORTS);
  }

  getCwp(): Observable<CwpResponse> {
    return this.http.get<CwpResponse>(CWP);
  }
}
